import { createContext, useContext } from 'react';
export const ValidationRulesOverrideContext = /*#__PURE__*/createContext({});
export const ValidationRulesOverrideProvider = ValidationRulesOverrideContext.Provider;
export const useValidationRulesOverride = () => {
  const {
    validationRulesOverride
  } = useContext(ValidationRulesOverrideContext);
  return validationRulesOverride;
};